import { render, staticRenderFns } from "./BienDetailsDpe.vue?vue&type=template&id=5a735c8f"
import script from "./BienDetailsDpe.vue?vue&type=script&lang=js"
export * from "./BienDetailsDpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports